export const LogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="143"
    height="143"
    viewBox="0 0 143 143"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="1"
        x2="-0.008"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#78c0ff" />
        <stop offset="0.494" stopColor="#08f" />
        <stop offset="1" stopColor="#305b81" />
      </linearGradient>
      <filter
        id="Rectangle_2"
        x="0"
        y="0"
        width="143"
        height="143"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx="5" dy="5" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="7.5" result="blur" />
        <feFlood floodOpacity="0.149" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Logo" transform="translate(18.359 18.359)">
      <g
        transform="matrix(1, 0, 0, 1, -18.36, -18.36)"
        filter="url(#Rectangle_2)"
      >
        <rect
          id="Rectangle_2-2"
          data-name="Rectangle 2"
          width="96"
          height="96"
          rx="5"
          transform="translate(18.5 18.5)"
          stroke="#fff"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
      </g>
      <g
        id="Group_25"
        data-name="Group 25"
        transform="translate(85.219 76.567) rotate(180)"
      >
        <path
          id="Path_6"
          data-name="Path 6"
          d="M15.123,2.327H3.49A1.169,1.169,0,0,0,2.327,3.49a12.872,12.872,0,0,0,12.8,12.8h.029a9.336,9.336,0,1,1-5.018,1.464A15.167,15.167,0,0,1,0,3.49,3.507,3.507,0,0,1,3.49,0H15.123a1.163,1.163,0,0,1,0,2.327ZM8.143,25.593a6.98,6.98,0,1,0,6.98-6.98A7.013,7.013,0,0,0,8.143,25.593Z"
          transform="translate(0 8.264)"
          fill="#fff"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M15.123,32.631H3.49a1.169,1.169,0,0,1-1.163-1.163,12.872,12.872,0,0,1,12.8-12.8h.029a9.336,9.336,0,1,0-5.018-1.464A15.167,15.167,0,0,0,0,31.467a3.507,3.507,0,0,0,3.49,3.49H15.123a1.163,1.163,0,0,0,0-2.327ZM8.143,9.365a6.98,6.98,0,1,1,6.98,6.98A7.013,7.013,0,0,1,8.143,9.365Z"
          transform="translate(74.156 43.222) rotate(180)"
          fill="#fff"
        />
        <path
          id="Path_8"
          data-name="Path 8"
          d="M18.919,12.3H12.3v6.622a1.892,1.892,0,0,1-3.784,0V12.3H1.892a1.892,1.892,0,0,1,0-3.784H8.513V1.892a1.892,1.892,0,1,1,3.784,0V8.513h6.622a1.892,1.892,0,1,1,0,3.784Z"
          transform="translate(40.811 3.784)"
          fill="#fff"
        />
        <path
          id="Path_9"
          data-name="Path 9"
          d="M24.594,3.784H5.676A1.9,1.9,0,0,0,3.784,5.676,20.934,20.934,0,0,0,24.594,26.486h.047a15.182,15.182,0,1,1-8.161,2.38A24.666,24.666,0,0,1,0,5.676,5.7,5.7,0,0,1,5.676,0H24.594a1.892,1.892,0,0,1,0,3.784ZM13.243,41.621A11.351,11.351,0,1,0,24.594,30.27,11.405,11.405,0,0,0,13.243,41.621Z"
          transform="translate(12.433)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
